import { ApostleBase } from '@apeiron/apostle'
import { MuiLoading } from '@apeiron/ui'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import ListEmptyState from '@src/components/share/list/ListEmptyState'
import ENV_CONFIG from '@src/config'
import { ROUTE } from '@src/constants/route'
import * as R from 'ramda'
import { ReactNode } from 'react'

const Container = styled(Box)`
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${props => props.theme.breakpoints.up('res1024')} {
    row-gap: 18px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    row-gap: 29px;
  }
`

const Loading = styled(MuiLoading)`
  position: absolute;
  top: calc(40% - 22px);
  left: calc(50% - 22px);
`

const ApostleList = <T extends ApostleBase>(props: Props<T>) => {
  const {
    apostles,
    className,
    emptyDescription,
    shouldShowEmptyRecommendation,
    loading = true,
    renderCard
  } = props

  return (
    <Container className={className}>
      {loading ? (
        <Loading loading />
      ) : R.isEmpty(apostles) ? (
        <ListEmptyState
          description={emptyDescription}
          buyURL={
            shouldShowEmptyRecommendation ? ROUTE.MARKETPLACE_APOSTLE_LIST : ''
          }
          rentURL={
            shouldShowEmptyRecommendation
              ? ENV_CONFIG.EXTERNAL_URL.LOOTRUSH.APOSTLE
              : ''
          }
        />
      ) : (
        <>
          {R.map(
            apostle => (
              <Box key={apostle.id}>{renderCard(apostle)}</Box>
            ),
            apostles
          )}
        </>
      )}
    </Container>
  )
}

type Props<T> = {
  apostles: T[]
  className?: string
  emptyDescription: string
  shouldShowEmptyRecommendation?: boolean
  loading: boolean
  renderCard: (apostle: T) => ReactNode
}

export default ApostleList
